import n from "./objectWithoutPropertiesLoose3.mjs";
import { getTodayDate as o, replaceInvalidDateByNull as u, areDatesEqual as i } from "./date-utils.mjs";
import { getDefaultReferenceDate as s } from "./getDefaultReferenceDate.mjs";
import { addPositionPropertiesToSections as c, createDateStrForInputFromSections as m } from "./useField.utils.mjs";
const V = ["value", "referenceDate"], D = {
  emptyValue: null,
  getTodayValue: o,
  getInitialReferenceValue: (r) => {
    let {
      value: e,
      referenceDate: t
    } = r, l = n(r, V);
    return e != null && l.utils.isValid(e) ? e : t ?? s(l);
  },
  cleanValue: u,
  areValuesEqual: i,
  isSameError: (r, e) => r === e,
  hasError: (r) => r != null,
  defaultErrorState: null,
  getTimezone: (r, e) => e == null || !r.isValid(e) ? null : r.getTimezone(e),
  setTimezone: (r, e, t) => t == null ? null : r.setTimezone(t, e)
}, T = {
  updateReferenceValue: (r, e, t) => e == null || !r.isValid(e) ? t : e,
  getSectionsFromValue: (r, e, t, l, a) => !r.isValid(e) && !!t ? t : c(a(e), l),
  getValueStrFromSections: m,
  getActiveDateManager: (r, e) => ({
    date: e.value,
    referenceDate: e.referenceValue,
    getSections: (t) => t,
    getNewValuesFromNewActiveDate: (t) => ({
      value: t,
      referenceValue: t == null || !r.isValid(t) ? e.referenceValue : t
    })
  }),
  parseValueStr: (r, e, t) => t(r.trim(), e)
};
export {
  T as singleItemFieldValueManager,
  D as singleItemValueManager
};
//# sourceMappingURL=valueManagers.mjs.map
